(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nav-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    const category = event.target.closest('.mdv-luxury-navigation .use-js-title-two');
    if (category) {
      for (const parent of category.closest('.toggol-menu-list').querySelectorAll('.submenu-2-head.active')) parent.classList.remove('active');
      return;
    }
    const control = event.target.closest('.mdv-luxury-navigation [data-nav-kind="primary"] > .use-js-title-one');
    if (!control) return;
    const item = control.parentElement;
    for (const sibling of item.parentElement.children) {
      if (sibling.dataset.navKind === 'primary') sibling.dataset.navSelected = String(sibling === item);
    }
  }, true);
  } catch(e) { console.error(e); }
})();

})();
